import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=8f40cfe4&scoped=true&"
import script from "./Instructions.vue?vue&type=script&lang=js&"
export * from "./Instructions.vue?vue&type=script&lang=js&"
import style0 from "./Instructions.vue?vue&type=style&index=0&id=8f40cfe4&scoped=true&lang=less&"
import style1 from "./Instructions.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f40cfe4",
  null
  
)

export default component.exports